import { render, staticRenderFns } from "./TaskPriorityCommonFilters.vue?vue&type=template&id=8cae38da&"
import script from "./TaskPriorityCommonFilters.vue?vue&type=script&lang=js&"
export * from "./TaskPriorityCommonFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports